import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = { class: "ss-tela-titulo" }
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = {
  key: 0,
  class: "atalhos",
  style: {"margin-left":"auto","margin-right":"auto","margin-bottom":"10px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Histórico", -1)
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-display-botao" }
const _hoisted_10 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_11 = { class: "ant-col ant-col-xs-14 ant-col-xl-18" }
const _hoisted_12 = { class: "ss-tela-titulo" }
const _hoisted_13 = {
  key: 0,
  class: "atalhos"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Histórico", -1)
const _hoisted_17 = { class: "ant-col ant-col-xs-10 ant-col-xl-6 ss-display-botao" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_historico_recurso_modal = _resolveComponent("historico-recurso-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.storeSistema.state.layoutMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.props.tituloRecurso), 1)
            ])
          ]),
          ((_ctx.props.empresasSelecionadas.length > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.props.exibirAtalhosTela)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.props.identificadorRecurso, _ctx.props.empresasSelecionadas))
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 0,
                            placement: "bottom"
                          }, {
                            title: _withCtx(() => [
                              _hoisted_6
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ss-icones-acoes",
                                style: {"color":"orange"},
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.props.identificadorRecurso, _ctx.props.empresasSelecionadas)))
                              }, [
                                _createVNode(_component_icone, { nome: "favorito" })
                              ])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 1,
                            placement: "bottom"
                          }, {
                            title: _withCtx(() => [
                              _hoisted_7
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ss-icones-acoes",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.props.identificadorRecurso, _ctx.props.empresasSelecionadas)))
                              }, [
                                _createVNode(_component_icone, { nome: "favorito" })
                              ])
                            ]),
                            _: 1
                          }))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.props.exibirHistoricoTela)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 1,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_8
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          class: "ss-icones-acoes",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.apresentarHistorico && _ctx.apresentarHistorico(...args)))
                        }, [
                          _createVNode(_component_icone, { nome: "historico" }),
                          _createVNode(_component_historico_recurso_modal, {
                            visivel: _ctx.stateTituloPadrao.exibirHistorico,
                            "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stateTituloPadrao.exibirHistorico) = $event)),
                            identificadorRecurso: _ctx.props.identificadorRecurso,
                            "empresas-selecionadas": _ctx.props.empresasSelecionadas,
                            "onUpdate:empresasSelecionadas": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.empresasSelecionadas) = $event))
                          }, null, 8, ["visivel", "identificadorRecurso", "empresas-selecionadas"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "ExtrasTitulo")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "BotoesAcoes")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.props.tituloRecurso), 1),
              ((_ctx.props.empresasSelecionadas.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_ctx.props.exibirAtalhosTela)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.props.identificadorRecurso, _ctx.props.empresasSelecionadas))
                            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                key: 0,
                                placement: "bottom"
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    class: "ss-icones-acoes",
                                    style: {"color":"orange"},
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removerAtalho(_ctx.props.identificadorRecurso, _ctx.props.empresasSelecionadas)))
                                  }, [
                                    _createVNode(_component_icone, { nome: "favorito" })
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_a_tooltip, {
                                key: 1,
                                placement: "bottom"
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    class: "ss-icones-acoes",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adicionarAtalho(_ctx.props.identificadorRecurso, _ctx.props.empresasSelecionadas)))
                                  }, [
                                    _createVNode(_component_icone, { nome: "favorito" })
                                  ])
                                ]),
                                _: 1
                              }))
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.props.exibirHistoricoTela)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 1,
                          placement: "bottom"
                        }, {
                          title: _withCtx(() => [
                            _hoisted_16
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ss-icones-acoes",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.apresentarHistorico && _ctx.apresentarHistorico(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "historico" }),
                              _createVNode(_component_historico_recurso_modal, {
                                visivel: _ctx.stateTituloPadrao.exibirHistorico,
                                "onUpdate:visivel": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stateTituloPadrao.exibirHistorico) = $event)),
                                identificadorRecurso: _ctx.props.identificadorRecurso,
                                "empresas-selecionadas": _ctx.props.empresasSelecionadas,
                                "onUpdate:empresasSelecionadas": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.props.empresasSelecionadas) = $event))
                              }, null, 8, ["visivel", "identificadorRecurso", "empresas-selecionadas"])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "ExtrasTitulo")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _renderSlot(_ctx.$slots, "BotoesAcoes")
          ])
        ]))
  ]))
}